import { flex, IconFont, pointer } from '@byecode/ui'
import styled, { css } from 'styled-components'

export const PageContainer = styled.div`
    position: relative;
    width: 100%;
    /* ${flex} */
    /* flex: 1; */
    height: 100%;
    background: #f2f2f3;
    display: flex;
    flex-direction: column;
`

export const PageContent = styled.div`
    position: relative;
    /* height: calc(100% - 96px); */
    flex: 1;
    width: 100%;
    display: flex;
    overflow: hidden;
`
